// Groups /store/'s flat catalog markup into item cards -- source
// content stays the editor's normal output for a titled item (an
// <h3> title, an image/gallery card, an <h3> of INFO/BANDCAMP-style
// links, a <p> description, one or more kg-button-card buttons, then
// an <h3>+++++</h3> divider), same approach as showsLedger.js: no
// markup to learn, just keep following the existing shape.

function isDivider(el) {
    return el.tagName === "H3" && el.textContent.trim() === "+++++";
}

function isSectionHeader(el) {
    return el.tagName === "H3" && el.id;
}

export default function storeCatalog() {
    const container = document.querySelector(".store-page .gh-content");
    if (!container) { return; }

    // The page's very first heading is the top jump nav (a row of
    // anchor links to each section) -- leave it in place, just tag it
    // for its own styling instead of wrapping it as an item.
    const jumpNav = Array.from(container.children).find((el) => el.tagName === "H3");

    let currentItem = null;

    Array.from(container.children).forEach((el) => {
        if (el === jumpNav && el.tagName === "H3") {
            el.classList.add("store-jump");
            return;
        }

        if (el.tagName === "HR" || isDivider(el) || isSectionHeader(el)) {
            if (isDivider(el)) { el.remove(); }
            currentItem = null;
            return;
        }

        if (el.tagName === "H3" && !currentItem) {
            currentItem = document.createElement("div");
            currentItem.className = "store-item";
            el.replaceWith(currentItem);
            currentItem.appendChild(el);
            return;
        }

        if (currentItem) {
            currentItem.appendChild(el);
        }
    });
}
